import React, { useContext } from 'react'
import reduce from 'lodash/reduce'
import StoreContext from '~/context/StoreContext'
import Cart from '~/icons/cart.svg'
import Logo from '~/images/logo.svg'
import { Paragon } from '~/components/Typography'
import {
  Header,
  Right,
  Left,
  Center,
  MenuLink,
  ButtonLink,
  ItemCount,
  GeneralLink,
  LogoLink,
  Label,
} from './styles'

const useQuantity = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)
  const items = checkout ? checkout.lineItems : []
  const total = reduce(items, (acc, item) => acc + item.quantity, 0)
  return [total !== 0, total]
}

export default ({ location }) => {
  const [hasItems, quantity] = useQuantity()

  return (
    <Header>
      <Left>
        <Paragon>
          <LogoLink href={'https://typeandmore.dk'}>
            <Logo />
          </LogoLink>
        </Paragon>
      </Left>
      <Center>
        <GeneralLink href="https://typeandmore.dk/pages/inspiration">
          Inspiration
        </GeneralLink>
        <GeneralLink href="https://typeandmore.dk/pages/sporgsmal-svar">
          Spørgsmål & Svar
        </GeneralLink>
      </Center>
      <Right>
        {location.pathname !== '/' && (
          <ButtonLink to={'/'}>Design din plakat</ButtonLink>
        )}
        <MenuLink to={'/cart'}>
          {location.pathname == '/' && (
            <Label>Din kurv</Label>
          )}
          {hasItems && <ItemCount>{quantity}</ItemCount>}
          <Cart />
        </MenuLink>
      </Right>
    </Header>
  )
}
